import React from 'react';
import { ConfigProvider } from 'antd';
import { Locale } from 'antd/lib/locale';

const withTheme = (node: JSX.Element, loc: Locale) => (
  <ConfigProvider
    locale={loc}
    prefixCls="next-antd"
    iconPrefixCls="next-antd-icon"
    theme={{
      token: {
        colorPrimary: `#725CFF`,
        borderRadius: 6,
        fontFamily: 'var(--font-inter)',
        fontSize: 16,
        colorLink: '#725CFF',
      },
      components: {},
    }}
  >
    {node}
  </ConfigProvider>
);

export default withTheme;
